export function pawsFilter(formElement) {
    let filterContainer = formElement.closest('[paws-filter]');

    if (filterContainer) {
        let filterType = filterContainer.getAttribute('paws-filter');

        if (filterType == 'change') {
            formElement.addEventListener('input', function (event) {
                formElement.querySelector('input[name="paws-page"]').value = 1;
                htmx.trigger(formElement, 'submit');
            });
        }

        filterContainer.addEventListener('click', function (event) {
            if (event.target.classList.contains('btn-loadmore')) {
                formElement.querySelector('input[name="paws-page"]').value = parseInt(formElement.querySelector('input[name="paws-page"]').value) + 1;
                formElement.setAttribute('hx-target', 'next .loadmore');
                formElement.setAttribute('hx-swap', 'outerHTML');
                htmx.process(formElement);
                htmx.trigger(formElement, 'submit');
            }
        });
    }
}